import React, { useState, useEffect } from "react";
import axios from "axios";
import { BASE_URL, IMAGE_URL } from "../Component/Baseurl";

const EventAgenda = ({ eventUniqueId }) => {
    const [sessions, setSessions] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchSessionsWithAgendas = async () => {
            try {
                const response = await axios.get(`${BASE_URL}fetch_sessions_agendas/${eventUniqueId}`);
                setSessions(response.data.sessions);
            } catch (err) {
                console.error("Error fetching sessions:", err);
                setError("Failed to fetch sessions. Please try again.");  // Show toast notification
            } finally {
                setLoading(false);
            }
        };

        fetchSessionsWithAgendas();
    }, [eventUniqueId]);

    // Helper function to convert time to 12-hour format with AM/PM
    const convertTo12HourFormat = (time) => {
        const [hours, minutes] = time.split(":").map(Number);
        const period = hours >= 12 ? "PM" : "AM";
        const adjustedHours = hours % 12 || 12; // Convert 0 to 12 for midnight
        return `${adjustedHours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')} ${period}`;
    };

    if (loading) {
        return <div>Loading...</div>; // Optional loading state
    }

    if (error) {
        return <div>{error}</div>; // Display error message if there's an error
    }

    return (
        <> 
            <div className="eventcard_container bg-salt p-2">
                <div className="head-label py-2  text-start">
                    <h2 className="h3clsss text-start mb-2">Schedule & Agenda</h2>
                    <hr/>
                    <div className="custom-accordion">
                        {sessions.map((session) => (
                            <div key={session.id} className="session-item mb-3">
                                <h3 className="session-name h3clsss">{session.session_name}</h3>
                                <div className="agenda-list">
                                    {session.agendas.length > 0 ? (
                                        session.agendas.map((agenda) => (
                                            <div key={agenda.id} className="agenda-item ">
                                                <div className="row ">
                                                    <div className="col-3 agendatxt">
                                                        {convertTo12HourFormat(agenda.start_time)} - {convertTo12HourFormat(agenda.end_time)}
                                                    </div>
                                                    <div className="col-9 ">
                                                        <div className="bdrsa">
                                                        <span className="agendatxt text-dark"><strong>{agenda.agenda_topic}</strong></span><br/>
                                                        <span className="agendatxt">{agenda.agenda_speaker}</span>
                                                        </div>
                                                        
                                                    </div>
                                                </div>
                                            </div>
                                        ))
                                    ) : (
                                        <p>No agendas available for this session.</p>
                                    )}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </>
    );
};

export default EventAgenda;
